import { createRouter, createWebHistory } from "vue-router";
import { ref } from "vue";
import HomeView from "../views/Home/HomeView.vue";
import LoginView from "../views/Auth/LoginView.vue";
import AdminSetupView from "../views/Admin/AdminSetupView.vue";
import AdminDashboardView from "../views/Admin/AdminDashboardView.vue";
import NoticiasView from "../views/Noticias/NoticiasView.vue";
import NoticiaDetailView from "../views/Noticias/NoticiaDetailView.vue";
import NoticiasAdminView from "../views/Admin/NoticiasAdminView.vue";
import NoticiaEditorView from "../views/Admin/NoticiaEditorView.vue";
import NoticiasCategoriasAdminView from "../views/Admin/NoticiasCategoriasAdminView.vue";
import HistoriasAdminView from "../views/Admin/HistoriasAdminView.vue";
import ResultadosView from "../views/Resultados/ResultadosView.vue";
import ResultadosAdminView from "../views/Admin/ResultadosAdminView.vue";
import ResultadoEditorView from "../views/Admin/ResultadoEditorView.vue";
import CategoriasAdminView from "../views/Admin/CategoriasAdminView.vue";
import CalendarioView from "../views/Calendario/CalendarioView.vue";
import FederacionView from "../views/Federacion/FederacionView.vue";
import HistoriasView from "../views/Historias/HistoriasView.vue";
import AlojamientoView from "../views/Alojamiento/AlojamientoView.vue";
import AlojamientoDetalleView from "../views/Alojamiento/AlojamientoDetalleView.vue";
import HistoriaDetailView from "../views/Historias/HistoriaDetailView.vue";
import JovenesPromesasView from "../views/JovenesPromesas/JovenesPromesasView.vue";
import JovenPromesaDetalleView from "../views/JovenesPromesas/JovenPromesaDetalleView.vue";
import JugadoresHistoricosView from "../views/JugadoresHistoricos/JugadoresHistoricosView.vue";
import JugadorHistoricoDetalleView from "../views/JugadoresHistoricos/JugadorHistoricoDetalleView.vue";
import CalendarioAdminView from "../views/Admin/CalendarioAdminView.vue";
import EventoEditorView from "../views/Admin/EventoEditorView.vue";
import PasadoView from "../views/PasadoFuturo/PasadoView.vue";
import PasadoDetailView from "../views/PasadoFuturo/PasadoDetailView.vue";
import FuturoView from "../views/PasadoFuturo/FuturoView.vue";
import FuturoDetailView from "../views/PasadoFuturo/FuturoDetailView.vue";
import PasadoFuturoAdminView from "../views/Admin/PasadoFuturoAdminView.vue";
import YoungPlayerEditorView from "../views/Admin/YoungPlayerEditorView.vue";
import ReferenteEditorView from "../views/Admin/ReferenteEditorView.vue";
import AdminUsersView from "../views/Admin/Users/AdminUsersView.vue";
import AsociacionesAdminView from "../views/Admin/AsociacionesAdminView.vue";
import AsociacionEditorView from "../views/Admin/AsociacionEditorView.vue";
import ClubesAdminView from "../views/Admin/ClubesAdminView.vue";
import ClubEditorView from "../views/Admin/ClubEditorView.vue";
import MiClubView from "../views/Admin/MiClubView.vue";
import ChangePasswordView from "../views/Auth/ChangePasswordView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import ImportDataAdminView from "../views/Admin/ImportDataAdminView.vue";
import SiteMediaAdminView from "../views/Admin/SiteMediaAdminView.vue";
import AlojamientoAdminView from "../views/Admin/AlojamientoAdminView.vue";
import SiteSettingsAdminView from "../views/Admin/SiteSettingsAdminView.vue";
import FederacionAdminView from "../views/Admin/FederacionAdminView.vue";
import { applyRouteSeo } from "../services/seo/seoService";
import { getToken, getStoredUser, getMe } from "../services/auth/authService";
import { ROLES, isDeveloper, isGeneralAdmin } from "../utils/roles";
import { obtenerSiteVisibility } from "../services/siteSettings/siteVisibilityService";
import {
  obtenerAdminAccess,
  obtenerModuloAdminPorRuta,
  puedeVerModulo,
} from "../services/admin/adminModulesService";
import ProvinciaAdminView from "../views/Admin/ProvinciaAdminView.vue";

const publicPageVisibility = {
  noticias: "pages.noticias",
  "noticia-detail": "pages.noticias",
  resultados: "pages.resultados",
  calendario: "pages.calendario",
  federacion: "pages.federacion",
  historias: "pages.historias",
  "historia-detail": "pages.historias",
  alojamiento: "pages.alojamiento",
  "alojamiento-detalle": "pages.alojamiento",
  "jóvenes-promesas": "pages.futuro",
  "joven-promesa-detalle": "pages.futuro",
  "jugadores-históricos": "pages.pasado",
  "jugador-histórico-detalle": "pages.pasado",
  pasado: "pages.pasado",
  "pasado-detail": "pages.pasado",
  futuro: "pages.futuro",
  "futuro-detail": "pages.futuro",
};

export const isRouteNavigating = ref(false);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // Públicas - Noticias
  {
    path: "/noticias",
    name: "noticias",
    component: NoticiasView,
  },
  {
    path: "/noticias/:id",
    name: "noticia-detail",
    component: NoticiaDetailView,
  },
  // Públicas - Resultados
  {
    path: "/resultados",
    name: "resultados",
    component: ResultadosView,
  },
  // Públicas - Calendario
  {
    path: "/calendario",
    name: "calendario",
    component: CalendarioView,
  },
  // Pública - La Federación
  {
    path: "/la-federacion",
    name: "federacion",
    component: FederacionView,
  },
  {
    path: "/la-federación",
    redirect: "/la-federacion",
  },
  // Pública - Historias y Notas
  {
    path: "/historias",
    name: "historias",
    component: HistoriasView,
  },
  {
    path: "/historias/:slug",
    name: "historia-detail",
    component: HistoriaDetailView,
  },
  // Pública - Alojamiento
  {
    path: "/alojamiento",
    name: "alojamiento",
    component: AlojamientoView,
  },
  {
    path: "/alojamiento/:slug",
    name: "alojamiento-detalle",
    component: AlojamientoDetalleView,
  },
  // Pública - Jóvenes Promesas
  {
    path: "/jóvenes-promesas",
    name: "jóvenes-promesas",
    component: JovenesPromesasView,
  },
  {
    path: "/jóvenes-promesas/:id",
    name: "joven-promesa-detalle",
    component: JovenPromesaDetalleView,
  },
  // Pública - Jugadores Históricos
  {
    path: "/jugadores-históricos",
    name: "jugadores-históricos",
    component: JugadoresHistoricosView,
  },
  {
    path: "/jugadores-históricos/:id",
    name: "jugador-histórico-detalle",
    component: JugadorHistoricoDetalleView,
  },
  // Rutas internas - escondidas
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { hideFromNav: true },
  },
  {
    path: "/admin/setup",
    name: "admin-setup",
    component: AdminSetupView,
    meta: { hideFromNav: true },
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminDashboardView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/importar",
    name: "admin-importar",
    component: ImportDataAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  {
    path: "/admin/alojamiento",
    name: "admin-alojamiento",
    component: AlojamientoAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  {
    path: "/admin/portadas",
    name: "admin-portadas",
    component: SiteMediaAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  {
    path: "/admin/configuracion",
    name: "admin-configuracion",
    component: SiteSettingsAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  {
    path: "/admin/federacion",
    name: "admin-federacion",
    component: FederacionAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  {
    path: "/admin/federacion",
    name: "admin-federacion",
    component: FederacionAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  // Admin - Noticias
  {
    path: "/admin/noticias",
    name: "admin-noticias",
    component: NoticiasAdminView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "NOTICIA" },
  },
  {
    path: "/admin/noticias/categorias",
    name: "admin-noticias-categorias",
    component: NoticiasCategoriasAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  {
    path: "/admin/noticias/nueva",
    name: "admin-noticia-nueva",
    component: NoticiaEditorView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "NOTICIA" },
  },
  {
    path: "/admin/noticias/editar/:id",
    name: "admin-noticia-editar",
    component: NoticiaEditorView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "NOTICIA" },
  },
  // Admin - Historias (mismo editor que noticias, parametrizado por meta.contentType)
  {
    path: "/admin/historias",
    name: "admin-historias",
    component: HistoriasAdminView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "HISTORIA" },
  },
  {
    path: "/admin/historias/nueva",
    name: "admin-historia-nueva",
    component: NoticiaEditorView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "HISTORIA" },
  },
  {
    path: "/admin/historias/editar/:id",
    name: "admin-historia-editar",
    component: NoticiaEditorView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "HISTORIA" },
  },
  // Admin - Notas (mismo editor, otra URL + otro type)
  {
    path: "/admin/notas",
    name: "admin-notas",
    component: HistoriasAdminView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "NOTA" },
  },
  {
    path: "/admin/notas/nueva",
    name: "admin-nota-nueva",
    component: NoticiaEditorView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "NOTA" },
  },
  {
    path: "/admin/notas/editar/:id",
    name: "admin-nota-editar",
    component: NoticiaEditorView,
    meta: { hideFromNav: true, requiresAuth: true, contentType: "NOTA" },
  },
  // Admin - Resultados / Torneos
  {
    path: "/admin/resultados",
    name: "admin-resultados",
    component: ResultadosAdminView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/resultados/nuevo",
    name: "admin-resultado-nuevo",
    component: ResultadoEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/resultados/editar/:id",
    name: "admin-resultado-editar",
    component: ResultadoEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/categorias",
    name: "admin-categorias",
    component: CategoriasAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
    },
  },
  // Admin - Calendario
  {
    path: "/admin/calendario",
    name: "admin-calendario",
    component: CalendarioAdminView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/calendario/nuevo",
    name: "admin-evento-nuevo",
    component: EventoEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/calendario/editar/:id",
    name: "admin-evento-editar",
    component: EventoEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  // Pública - Pasado y Futuro
  {
    path: "/pasado-futuro",
    redirect: "/pasado",
  },
  {
    path: "/pasado",
    name: "pasado",
    component: PasadoView,
  },
  {
    path: "/pasado/:slug",
    name: "pasado-detail",
    component: PasadoDetailView,
  },
  {
    path: "/futuro",
    name: "futuro",
    component: FuturoView,
  },
  {
    path: "/futuro/:slug",
    name: "futuro-detail",
    component: FuturoDetailView,
  },
  // Admin - Pasado y Futuro
  {
    path: "/admin/pasado-futuro",
    name: "admin-pasado-futuro",
    component: PasadoFuturoAdminView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/pasado-futuro/joven/nuevo",
    name: "admin-joven-nuevo",
    component: YoungPlayerEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/pasado-futuro/joven/editar/:id",
    name: "admin-joven-editar",
    component: YoungPlayerEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/pasado-futuro/referente/nuevo",
    name: "admin-referente-nuevo",
    component: ReferenteEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  {
    path: "/admin/pasado-futuro/referente/editar/:id",
    name: "admin-referente-editar",
    component: ReferenteEditorView,
    meta: { hideFromNav: true, requiresAuth: true },
  },
  // Admin - Cambio de contraseña (sin requiresAuth para que el backend no bloquee,
  // la lógica de redirección se hace en el guard de abajo)
  {
    path: "/admin/cambiar-password",
    name: "admin-cambiar-password",
    component: ChangePasswordView,
    meta: { hideFromNav: true, requiresChange: true },
  },
  // Admin - Gestión de usuarios
  {
    path: "/admin/usuarios",
    name: "admin-usuarios",
    component: AdminUsersView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },
  // Admin - Asociaciones regionales (solo BOCHAS_ADMIN, con permiso total para desarrollador)
  {
    path: "/admin/asociaciones",
    name: "admin-asociaciones",
    component: AsociacionesAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
    },
  },
  {
    path: "/admin/asociaciones/nueva",
    name: "admin-asociación-nueva",
    component: AsociacionEditorView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
    },
  },
  {
    path: "/admin/asociaciones/editar/:id",
    name: "admin-asociación-editar",
    component: AsociacionEditorView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
    },
  },
  // Admin - Clubes (BOCHAS_ADMIN y Asociación_ADMIN crean; CLUB_ADMIN edita solo el suyo)
  {
    path: "/admin/clubes",
    name: "admin-clubes",
    component: ClubesAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [
        ROLES.BOCHAS_ADMIN,
        ROLES.Asociación_ADMIN,
        ROLES.CLUB_ADMIN,
      ],
    },
  },
  {
    path: "/admin/clubes/nueva",
    name: "admin-club-nuevo",
    component: ClubEditorView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
    },
  },
  {
    path: "/admin/clubes/editar/:id",
    name: "admin-club-editar",
    component: ClubEditorView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [
        ROLES.BOCHAS_ADMIN,
        ROLES.Asociación_ADMIN,
        ROLES.CLUB_ADMIN,
      ],
    },
  },

  {
    path: "/admin/provincia",
    name: "admin-provincia",
    component: ProvinciaAdminView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.BOCHAS_ADMIN],
      requiresGeneralAdmin: true,
    },
  },

  // Admin - "Mi Club" para CLUB_ADMIN
  {
    path: "/admin/mi-club",
    name: "admin-mi-club",
    component: MiClubView,
    meta: {
      hideFromNav: true,
      requiresAuth: true,
      requiresRole: [ROLES.CLUB_ADMIN],
    },
  },
  // Catch-all: 404 para cualquier ruta no matcheada
  // (debe ir AL FINAL del array, después de todas las rutas específicas)
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // Política de scroll al cambiar de ruta:
  //   1. Si el usuario navega con back/forward del browser, restauramos la
  //      posición dónde estaba (savedPosition la maneja vue-router solo).
  //   2. Si va a una sección con hash (#id), saltamos al ancla.
  //   3. En cualquier otro caso (link normal), top 0 instantáneo.
  // El smooth-scroll al top solo lo dispara el botón flotante, no la navegación —
  // así la transición entre páginas se siente snappy.
  scrollBehavior(to, from, savedPosition) {
    if (to.name === "home" && !to.hash) {
      return { top: 0, left: 0 };
    }
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 80 };
    }
    return { top: 0, left: 0 };
  },
});

router.beforeEach(() => {
  isRouteNavigating.value = true;
});

router.beforeEach(async (to) => {
  const visibilityKey = publicPageVisibility[to.name];
  if (visibilityKey) {
    try {
      const visibility = await obtenerSiteVisibility();
      if (visibility[visibilityKey] === false) {
        // Los admins pueden ver páginas aunque estén ocultas
        const user = getStoredUser();
        if (!user || !isGeneralAdmin(user)) {
          return { name: "home" };
        }
      }
    } catch (_) {
      // Si la configuración no está disponible, mantener navegable el sitio.
    }
  }

  // Si el usuario está logueado y tiene mustChangePassword: true,
  // forzar redirección a /admin/cambiar-password (excepto si ya está ahí o si va a logout).
  const token = getToken();
  if (token && !to.meta.requiresChange) {
    const stored = getStoredUser();
    if (
      stored &&
      stored.mustChangePassword &&
      to.name !== "login" &&
      to.name !== "admin-cambiar-password"
    ) {
      return { name: "admin-cambiar-password" };
    }
  }

  if (to.meta.requiresAuth) {
    if (!token) {
      return { name: "login" };
    }
    const user = await getMe();
    if (!user) {
      return { name: "login" };
    }
    // Si el backend devolvió mustChangePassword (porque cambió después del login),
    // guardar el flag y redirigir a cambiar-password
    if (user.mustChangePassword && to.name !== "admin-cambiar-password") {
      const local = getStoredUser();
      if (local) {
        local.mustChangePassword = true;
        localStorage.setItem("bochas_user", JSON.stringify(local));
      }
      return { name: "admin-cambiar-password" };
    }
    // Validar rol si la ruta lo requiere.
    // Si el user está autenticado pero NO tiene el rol, redirigir al panel
    // (que se filtra solo según el rol del user).
    // Excepción: si es desarrollador (isDeveloper=true), bypasea cualquier
    // check de rol — puede entrar a cualquier ruta admin.
    if (to.meta.requiresRole && Array.isArray(to.meta.requiresRole)) {
      const isDev = isDeveloper(user);
      if (!isDev && !to.meta.requiresRole.includes(user.role)) {
        return { name: "admin" };
      }
    }
    if (to.meta.requiresDeveloper && !isDeveloper(user)) {
      return { name: "admin" };
    }
    if (to.meta.requiresGeneralAdmin && !isGeneralAdmin(user)) {
      return { name: "admin" };
    }
    const adminModule = obtenerModuloAdminPorRuta(to.path);
    if (adminModule) {
      try {
        const adminAccess = await obtenerAdminAccess();
        if (!puedeVerModulo(adminAccess, adminModule, user)) {
          return { name: "admin" };
        }
      } catch (_) {
        // Si la configuración no está disponible, conservar los permisos base.
      }
    }
  }
});

router.afterEach((to) => {
  isRouteNavigating.value = false;
  applyRouteSeo(to);
});

router.onError(() => {
  isRouteNavigating.value = false;
});

export default router;
